<template>
    <div class="division-label body-box">
      <div class="division-label-left">
        <Tree
          @changeSwitch="changeSwitch"
          :switchVal="searchParams.isDown"
          :levelNum="3"
          @nodeClick="nodeClick"
        ></Tree>
      </div>
      <div class="division-label-righ">
        <TabelSearch
          :searchConfig="searchConfig"
          :searchParams="searchParams"
          @resetCallBack="resetCallBack"
          @search="setSearchParams"
        ></TabelSearch>
        <Table
          :width="'100%'"
          :tableLoading="tableLoading"
          :tabelButtons="tabelButtons"
          :templateData="tableTemplateData"
          :tableConfig="tableConfig"
          :pagination="pagination"
        >
        </Table>
      </div>
    </div>
  </template>
  
  <script>
  import Tree from "../Tree/nodeTreeOrgin";
  import Table from "../table/table";
  import TabelSearch from "../tabel-search/tabel-search";
  import { vidiconApi } from "../../api-path/vidicon-api";
  export default {
    name: "cascadePage",
    props: {
        btnOpts: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: ''
        }
    },
    //editForm
    components: {
      Table,
      TabelSearch,
      Tree,
    },
    data() {
      return {
        searchParams: {
          name: "", //摄像头名称
          areaId: "",
          bindingType: false, // 是否绑定过
          isDown: false, //是否想下查询
          // report: '', // 是否终止上报
          // open: '', // 是否开放
          page: 1,
          size: 15,
        },
        searchConfig: {
          dataName: "searchParams",
          items: [
            {
              key: "name",
              valueType: "text",
              placeholder: "请输入摄像头名称",
            },
            {
              key: "bindingType",
              valueType: "switch",
              placeholder: "是否绑定过",
            },
          ],
        },
        //表格
        tableLoading: false,
        tableTemplateData: [],
        tabelButtons: [],
        tableConfig: {
          checkbox: true,
          index: true,
          checkboxFn: (data) => {
          },
          rows: [
            {
              label: "摄像头名称",
              prop: "name",
            },
            {
              label: "摄像头编号",
              prop: "cameraIndexCode",
            },
            {
              label: "摄像头类型",
              prop: "cameraType",
            },
            {
              label: "摄像头像素",
              prop: "pixel",
            },
            {
              label: "在线状态",
              prop: "status",
            },
            {
              label: "通道号",
              prop: "chanNum",
            },
            {
              label: "安装位置",
              prop: "installPlace",
            },
          ],
          rowButtons: {},
        },
        pagination: {
          show: true,
          total: 0,
          page: 1,
          size: 15,
          sizeChange: this.sizeChange,
          pageChange: this.pageChange,
        }, // 分页
        rowButtons: {
          width: "100px",
          items: [
            {
              label: "绑定",
              fn: (data) => {
                this.$confirm('确定绑定当前摄像头?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    let obj = {
                      cameraId: this.id,
                      thirdCameraId: data.id
                    }
                    this.$http.post(vidiconApi.cameraGatewayBindingData, obj)
                        .then((res) => {
                          if (res.status === 200) {
                            this.$message.success('绑定成功')
                            this.$emit('closePage')
                            this.setSearchParams()
                          }
                        });

                  })
              },
            },
          ],
        },
      };
    },
    created() {
        if (this.btnOpts) {
            this.tableConfig.rowButtons = this.rowButtons
        }
    },
    methods: {
      changeSwitch(e) {
        this.searchParams.isDown = e;
        this.isDown = e;
        this.startSearch();
      },
      nodeClick(node) {
        this.searchParams.areaId = node.areaId;
        this.areaId = node.areaId;
        this.searchParams.page = this.pagination.page = 1;
        this.startSearch();
      },
      startSearch() {
        this.$http
          .get(vidiconApi.cameraGatewayPageList, {
            params: this.searchParams,
          })
          .then((res) => {
            if (res.status == 200) {
              this.tableTemplateData = res.result.pageList;
              this.pagination.total = res.result.total;
            }
          });
      },
      setSearchParams(value) {
        if (value) {
          this.pagination.page = value.page;
        }
        this.startSearch();
      },
      resetCallBack() {
        this.searchParams.areaId = this.areaId;
        this.searchParams.isDown = this.isDown;
        this.searchParams.page = this.pagination.page = 1;
        this.startSearch();
      },
      // 每页显示条数
      sizeChange(size) {
        this.pagination.size = size;
        this.searchParams.size = size;
        this.startSearch();
      },
      // 当前页
      pageChange(page) {
        this.pagination.page = page;
        this.searchParams.page = page;
        this.startSearch();
      },
      //--------------end
    },
  };
  </script>
  
  <style scoped lang="less">
  .division-label {
    margin-left: 10px;
    box-sizing: border-box;
    height: 100%;
    padding: 10px;
    border-radius: 10px;
    background: #fff;
    display: flex;
    .division-label-left {
      margin-right: 10px;
      border-right: 1px solid #c1c1c1;
    }
  
    .division-label-righ {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
  </style>
  